module.exports = "<nv-react-component component=\"PersonalizedTakeawaysPage\"></nv-react-component>";